// extracted by mini-css-extract-plugin
export default {"productReport":"ProductReport_productReport__AAsng"};